import './loading-state.css';

const BOOT_STAGES = {
  session: { completed: 0, label: '로그인 상태 확인 중' },
  union: { completed: 1, label: '유니온 정보 동기화 중' },
};

/** Progress means completed lifecycle stages, never elapsed time or downloaded bytes. */
export function ControlBoot({ stage = 'session' }) {
  const { completed, label } = BOOT_STAGES[stage] || BOOT_STAGES.session;
  return <main className="dp-boot" aria-busy="true">
    <div className="dp-boot__content">
      <div className="dp-boot__identity"><strong>DOROPARTY</strong><span>CONTROL BOOT</span></div>
      <div className="dp-boot__status" role="status"><span>{label}</span><span aria-hidden="true">{completed}/2</span></div>
      <progress className="dp-boot__progress" value={completed} max={2} aria-label="초기화 단계" aria-valuetext={`${label}, 2단계 중 ${completed}단계 완료`} />
    </div>
  </main>;
}

/** Layout variants describe the waiting content without pretending it has loaded. */
export function Skeleton({ variant = 'card', count = 3 }) {
  const shape = ['member', 'boss', 'chat', 'card'].includes(variant) ? variant : 'card';
  return <div className={`dp-skeleton dp-skeleton--${shape}`} aria-hidden="true">
    {Array.from({ length: Math.max(1, Math.min(8, count)) }, (_, index) => <div className="dp-skeleton__item" key={index}>
      <i className="dp-skeleton__shape" /><div className="dp-skeleton__lines"><i /><i /></div>
    </div>)}
  </div>;
}

export function LoadingState({ label = '데이터 동기화 중', variant = 'card', count = 3 }) {
  return <section className="dp-loading" aria-busy="true">
    <p className="dp-loading__label" role="status">{label}</p>
    <Skeleton variant={variant} count={count} />
  </section>;
}
